<template>
  <p>
    <slot></slot>
    <a hidden :herf="year"></a>
    <span v-if="author!==''"> {{ author }}, </span>
    <span v-if="title!==''"> {{ title }}, </span>
    <span v-if="journal!==''" class="journal">{{ journal }} </span>
    <span v-if="volume!==''">{{ volumn }}</span>
    <span v-if="issue!==''">({{ issue }})</span>
    <span v-if="pages!==''">:{{ pages }}, </span>
    {{ year }}.
    <span v-if="doi!==''">DOI: <a :href="getDoi" target="_blank" style="word-break: break-word">{{ getDoi }}</a></span>

  </p>
</template>

<script>
export default {
  name: "Publication",
  props: {
    author: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    journal: {
      type: String,
      default: ''
    },
    volume: {
      type: String,
      default: ''
    },
    issue: {
      type: String,
      default: ''
    },
    pages: {
      type: String,
      default: ''
    },
    doi: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    year: {
      type: String,
      default: ''
    },
  },
  computed:{
    getDoi(){
      return this.doi.startsWith('http')?this.doi:'https://doi.org/'+this.doi
    }
  }
}
</script>

<style scoped>
.journal {
  font-style: italic;
  font-weight: bold;
}
a{
  color: dodgerblue;
}
</style>